function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(-239.89 -81.942)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_502",
  "data-name": "Grupo 502",
  transform: "translate(240.649 82.704)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_844",
  "data-name": "Caminho 844",
  d: "M252.039,105.445a11.373,11.373,0,1,1,9-18.308h0a11.37,11.37,0,0,1-9,18.308Zm-.024-21.066a9.695,9.695,0,1,0,7.7,3.78h0A9.691,9.691,0,0,0,252.015,84.378Z",
  transform: "translate(-240.65 -82.704)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_503",
  "data-name": "Grupo 503",
  transform: "translate(257.496 101.534)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1402",
  "data-name": "Ret\\xE2ngulo 1402",
  width: 1.676,
  height: 15.326,
  transform: "translate(0 1.022) rotate(-37.574)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.5
})));

function SvgTransparentSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.331,
    height: 33.813,
    viewBox: "0 0 29.331 33.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentSearch);
export default __webpack_public_path__ + "static/media/transparentSearch.87c7a395.svg";
export { ForwardRef as ReactComponent };